import { store } from "react-notifications-component";
import "react-notifications-component/dist/theme.css";
// import "animate.css";

export function Notification(
  title,
  message = "Something Went Wrong",
  type = undefined
) {
  // store to create dynamic message using react-notification
  store.addNotification({
    width: 250,
    title: title,
    message: message,
    type: type ? type : "danger",
    container: "top-right",
    animationIn: ["animated", "fadeIn"],
    animationOut: ["animated", "fadeOut"],
    dismiss: {
      duration: 3000
    }
  });
}

export default Notification;